import { defineComponent as _defineComponent } from 'vue'
import { twMerge } from 'tailwind-merge'
import { computed, inject } from 'vue'
import { storeToRefs } from 'pinia'

import { useCommandStore } from './useCommandStore'
import { optionsInjectionKey } from './utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'CommandEmpty',
  props: {
    twClass: null
  },
  setup(__props: any) {



const { shouldFilter, storeId } = inject(optionsInjectionKey, {
  shouldFilter: true,
  storeId: '',
})

const commandStore = useCommandStore(storeId)
const { items, isSearching, filtered } = storeToRefs(commandStore)

const shouldRender = computed(() => {
  if (!shouldFilter && items.value.length > 0) {
    return false
  }
  return isSearching.value && filtered.value.count === 0
})

return { __sfc: true,shouldFilter, storeId, commandStore, items, isSearching, filtered, shouldRender, twMerge }
}

})